import './navbar.css';
import React, { useState, useEffect } from "react";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { images } from "../../constants";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export const Navbar = () => {
  const [navbar, setNavbar] = useState(false);
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const showLanguageToast = (message) => {
    toast.info(message, {
      className: 'toast-info',
      icon: false
    });
  };
  
  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    localStorage.setItem("lang", newLang);
    i18n.changeLanguage(newLang);
    showLanguageToast(t("toast_change_language"));
  };

  const toggleNavbar = () => {
    setNavbar(!navbar);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setNavbar(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <ToastContainer position="bottom-center" />
      <div>
        <nav
          data-testid="navbar"
          className="w-full bg-white drop-shadow-lg relative z-10"
        >
          <div className="flex-no-wrap relative fixed flex flex-row justify-between pl-8 pt-4 pb-4">
            <div>
              <div className="flex items-center justify-between pt-2 md:block">
                <img
                  src={images.senarai}
                  alt="senarai"
                  style={{ width: "190px", height: "35px" }}
                />
                <div data-testid="dropdown-menu" className="md:hidden">
                  <button
                    className="text-2xl text-[#2D3494] absolute pt-4 top-4 right-4 z-50"
                    onClick={toggleNavbar}
                  >
                    {navbar ? (
                      <IoMdClose aria-label="Close Menu" />
                    ) : (
                      <IoMdMenu aria-label="Toggle Menu" />
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div
              className={`${
                navbar
                  ? "absolute top-full h-screen pb-16 z-20 left-0 w-full justify-center items-center bg-white"
                  : "hidden"
              } md:flex md:flex-row md:items-center md:justify-end`}
              data-testid="nav-buttons"
            >
              <ul className="h-auto items-center justify-center md:flex">
                <li className="text-white py-2 md:px-6 text-center">
                  <a href="/login">
                    <button
                      data-testid="navbar-login-button"
                      className="bg-transparent py-2 px-4 text-[#2D3494] hover:text-white border border-[#2D3494] hover:bg-[#2D3494] font-lato rounded-xl"
                    >
                      {t("navbar_login")}
                    </button>
                  </a>
                </li>
                <li className="text-white py-2 md:px-6 text-center">
                  <a href="/register">
                    <button
                      data-testid="navbar-signup-button"
                      className="bg-[#2D3494] hover:bg-white text-white font-lato hover:text-[#2D3494] hover:border border-[#2D3494] py-2 px-4 rounded-xl "
                    >
                      {t("navbar_signup")}
                    </button>
                  </a>
                </li>
                <li
                  className="text-white py-2 md:px-6 text-center items-center relative md:mr-10"
                >
                  <select
                    value={i18n.language}
                    onChange={handleLanguageChange}
                    data-testid="language-dropdown"
                    className="bg-transparent font-lato text-black py-2 px-4 border border-gray-400 shadow-md rounded-xl"
                  >
                    <option value="en" data-testid="en">English</option>
                    <option value="id" data-testid="id">Indonesia</option>
                  </select>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

